__turbopack_context__.v({
  "root": "LandingHeroRotator-module-scss-module__pDeHGq__root",
});
